import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';

const cardStyle = {
  marginTop: '20px',
  paddingBottom: '5px'
};

const contentStyle = {
  padding: '20px 70px',
  textAlign: 'justify'
};

const listItemStyle = {
  fontSize: 15
};

const ConfidentialityText = ({ title, children }) => (
  <>
    <Typography style={listItemStyle} mt={5}>
      <strong>{title}</strong>
    </Typography>
    <br />
    <Typography style={listItemStyle}>{children}</Typography>
  </>
);

export const AllianceConfidentiality = () => (
  <MainCard style={cardStyle} className="animate__animated animate__fadeIn">
    <Box style={contentStyle}>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item xs={12}>
          <h1 style={{ lineHeight: '1.2', textAlign: 'center' }}>Terminos y condiciones para el manejo de la información</h1>
        </Grid>
      </Grid>
      <Box>
        <ol type="I">
          <li>
            <ConfidentialityText title={'Reconocimiento de la Información Confidencial'}>
              Al solicitar acceso a información sobre proyectos estratégicos u otros datos no públicos, el solicitante reconoce que dicha
              información se considera confidencial de acuerdo con lo establecido en el literal f) del artículo 6 de la Ley de Acceso a la
              Información Pública. Esto, partiendo del mandato legal establecido en la Ley General para la Modernización Digital del Estado
              bajo el cual reconoce de manera general y obligatoria, los compromisos internacionales que el Estado adquiera como la Alianza
              Estratégica suscrita entre el Gobierno de la República de El Salvador, y Google LLC.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Compromiso de Confidencialidad'}>
              El solicitante se compromete a mantener en estricto secreto y confidencialidad toda la información y documentación que obtenga
              o esté bajo su control relacionada una vez tenga acceso a la información por descargar.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Uso Restringido de la Información'}>
              La información confidencial no podrá ser divulgada ni utilizada para beneficio personal, comercial o en favor de terceros sin
              autorización expresa del Gobierno de la República de El Salvador.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Responsabilidad Posterior'}>
              La obligación de confidencialidad persistirá incluso después de que finalice la Alianza Estratégica y mientras la información
              conserve su carácter confidencial.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Medidas de Protección'}>
              El solicitante se compromete a adoptar medidas necesarias para restringir el acceso a la información confidencial, tanto
              verbal como documental, y a proteger los archivos electrónicos que contengan dicha información.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Consecuencias de Incumplimiento'}>
              El incumplimiento de estas cláusulas implicará responsabilidad civil y penal ante las autoridades competentes.
            </ConfidentialityText>
          </li>
          <li>
            <ConfidentialityText title={'Excepciones'}>
              Se reconocen excepciones en caso de que la información sea de dominio público, sea revelada con autorización expresa del
              Gobierno de El Salvador, o se divulgue por mandato legal.
            </ConfidentialityText>
          </li>
        </ol>
        <ConfidentialityText>
          Estos términos y condiciones han sido expresados y aceptados voluntariamente por el solicitante, quien reconoce su contenido y los
          efectos legales que conlleva.
        </ConfidentialityText>
      </Box>
    </Box>
  </MainCard>
);
